export function translateToGerman(text) {
  const germanTranslations = {
    'Chest width': 'Brustweite',
    'Sleeve width': 'Ärmelweite',
    'Sleeve length': 'Ärmellänge',
    'Shoulder width': 'Schulterbreite',
    'Body length': 'Körperlänge',
    'Hip width': 'Hüftbreite',
    'Waist width': 'Taillenweite',
    'Thigh width': 'Oberschenkelweite',
    'Body front length': 'vordere Länge des Körper',
    'Body back length': 'Rückenlänge des Körper',
    Length: 'Länge',
    Width: 'Breite',
    'Fringe length': 'Fransenlänge',
    'ONE-SIZE': 'Einheitsgröße',
    'FREE-SIZE': 'Einheitsgröße',
    EU: 'EU',
    US: 'USA',
    UK: 'UK',
    Russia: 'Russland',
    Asia: 'Asien',
    Size: 'Größe',
    'Size guide': 'Größentabelle',
  };
  let germanTranslation = germanTranslations[text];
  if (germanTranslation === undefined) {
    return text;
  } else {
    return germanTranslation;
  }
}
